import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import { makeStyles } from '@material-ui/core/styles';

import config from '../../../../config';

const useStyles = makeStyles(() => ({
  iframe: {
    border: '0',
    width: '100%',
    boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.05) !important',
    backgroundColor: '#fff',
  },
  rise: {
    height: '100rem',
  },
  storyline: {
    height: '96%',
  },
}));

const StorylineContent = ({
  filename, launchPoint, userName, email, activityId, rise,
}) => {
  const classes = useStyles();
  return (
    <Iframe
      loading="Loading..."
      className={`${classes.iframe} ${rise ? classes.rise : classes.storyline}`}
      url={`${config.OBJECT_URL}/content/${filename}/${launchPoint}?endpoint=${config.LRS_ENDPOINT}&actor={%22name%22:%20[%22${encodeURI(userName)}%22],%20%22mbox%22:%20[%22mailto:${encodeURI(email.trim())}%22]}&activity_id=http://${activityId}&tincan=true`}
      title="StorylineFrame"
    />
  );
};

StorylineContent.propTypes = {
  filename: PropTypes.string.isRequired,
  launchPoint: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  activityId: PropTypes.string.isRequired,
  rise: PropTypes.string.isRequired,
};

export default StorylineContent;
